import React from 'react';
import BasicModal from "../../components/common/BasicModal";
import ResourceForm from "../../components/forms/ResourceForm";
import components from "components/forms/Component Sets/UnvalidatedBasicFormComponents";
import config from "./storeFinderImportConfig";

const StoreFinderImportModal = (props) => {

    return (
        <BasicModal header={"Store Finder Import"}
                    specialType="primary-modal db-store-finder-import-modal fadeInUp animResponse"
                    dimmer={'inverted'}
                    modalSize="small"
                    actions={[
                        {
                            label: "Cancel",
                            action: props.handleClose,
                            displayType: "menu-item"
                        },
                        {
                            label: "Save",
                            action: props.submit,
                            displayType: "button",
                            primaryCheck: true
                        }
                    ]}
                    open={props.modalOpen}
                    onClose={props.handleClose}>

            <ResourceForm resource={props.formData}
                          config={config}
                          components={components}
                          errors={props.errors}
                          onValueChanged={props.onValueChanged}
                          onValidationError={props.onValidationError}/>
        </BasicModal>
    )
};

export default StoreFinderImportModal;


// WEBPACK FOOTER //
// ./public/pages/StoreFinderImport/StoreFinderImportModal.jsx